var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcControllerSubmenu({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 7.25V14.75H14.75V7.25H7.25ZM13.25 13.25H8.75V8.75H13.25V13.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 8.75V7.25H18.5V5C18.5 4.6 18.34 4.22 18.06 3.94C17.78 3.66 17.4 3.5 17 3.5H14.75V0.5H13.25V3.5H8.75V0.5H7.25V3.5H5C4.6 3.5 4.22 3.66 3.94 3.94C3.66 4.22 3.5 4.6 3.5 5V7.25H0.5V8.75H3.5V13.25H0.5V14.75H3.5V17C3.5 17.4 3.66 17.78 3.94 18.06C4.22 18.34 4.6 18.5 5 18.5H7.25V21.5H8.75V18.5H13.25V21.5H14.75V18.5H17C17.4 18.5 17.78 18.34 18.06 18.06C18.34 17.78 18.5 17.4 18.5 17V14.75H21.5V13.25H18.5V8.75H21.5ZM17 17H5V5H17V17Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcControllerSubmenu);
export default __webpack_public_path__ + "static/media/ic-controller-submenu.32e5b7e7d8c2bb2b24acf05347176a1c.svg";
export { ForwardRef as ReactComponent };